/* eslint-disable max-len */
import { envVal } from '@root/config/config';
import moment from 'moment';
import { getStreamPlaceOrEvent } from "@kursk/content/contentUtils";
import { capitalize } from 'lodash';

const year = new Date().getFullYear();

const tagPageDefaultSeo = {
  title: ({ tagName }) => `${tagName[0].toUpperCase() + tagName.slice(1)} в Благовещенске ${year}. Официальный сайт — Культура Амура`,
  description: ({ tagName }) => `${tagName[0].toUpperCase() + tagName.slice(1)} в Благовещенске. Подробная информация о событиях: расписания, описания, фото, места проведения, цены на билеты. Официальный сайт — Культура Амура`,
  titleOg: () => '',
  h1: ({ tagName }) => tagName
};
const tagPageDefaultSeoEvents = {
  title: ({ title }) => `${title[0].toUpperCase() + title.slice(1)} в Благовещенске ${year}. Официальный сайт — Культура Амура`,
  description: ({ title }) => `${title[0].toUpperCase() + title.slice(1)} в Благовещенске. Подробная информация о событиях: расписания, описания, фото, места проведения, цены на билеты. Официальный сайт — Культура Амура`,
  titleOg: () => '',
};
const tagPageDefaultSeoPlaces = {
  title: ({ title }) => `${title[0].toUpperCase() + title.slice(1)} Благовещенска. Официальный сайт — Культура Амура`,
  description: ({ title }) => `${title[0].toUpperCase() + title.slice(1)} в Благовещенске. Подробная информация о местах: описания, адреса, телефоны, сайты, фото, расписание. Официальный сайт — Культура Амура`,
  titleOg: () => '',
};

export const amurContent = {
  timezone: 'Europe/Moscow',
  yandexMapState: {
    center: [50.249266, 127.553278],
    zoom: 9,
  },
  locale: { _id: 229 },
  title: 'Культура Амура',
  subTitle: 'Культура Амура',
  mainBanner: {
    hide: true,
    title: '',
    text: '',
    links: []
  },
  eventCardShowZIcon: true,
  zIconTagName: 'uchastnikam-svo',
  useBvi: false,
  phone: '',
  mail: 'help@culture.amurobl.ru',
  agreementLink: '/public_offer',
  agreementFilePath: '/docs/public_offer_14_11_2025.pdf',
  policyLink: '/privacy',
  policyFilePath: '/docs/privacy_policy_26_05_2026.pdf',
  socials: {
    ok: 'https://ok.ru/group/60648608563321',
    vk: 'https://vk.com/minkultamur',
    yaDzen: '',
    telegram: 'https://t.me/minkultamur',
    facebook: '',
    instagram: '',
  },
  socialTitles: {
    vk: 'вконтакте',
    telegram: 'Telegram',
  },
  subscribeForm: {
    title: 'Узнавайте новости культуры первыми',
  },
  filters: {
    touristroutes: {
      transportationMethodTitle: 'Тип маршрута',
    },
  },
  header: {
    links: [
      {
        title: 'Афиша',
        relativeLink: '/events',
        links: [
          { title: 'Все события', to: '/events' },
          { title: 'Пушкинская карта', to: '/events/tag-pushkinskaya-karta' },
          { title: 'Концерты и шоу', to: '/events/tag-koncerty-i-shou' },
          { title: 'Спектакли', to: '/events/tag-spektakli' },
          { title: 'Выставки', to: '/events/tag-vystavki' },
          { title: 'Мастер-классы', to: '/events/tag-master-klassy' },
          { title: 'Кино', to: '/movies' },
          { title: 'Фестивали', to: '/events/tag-festivali' },
          { title: 'Праздники', to: '/events/tag-prazdniki' }
        ]
      },
      { title: 'Места', to: '/places' },
      { title: 'Маршруты', to: '/touristroutes' },
      { title: 'Обзоры', to: '/overviews' },
      {
        title: 'Live',
        links: [
          { to: '/streams', title: 'Трансляции' },
          { to: '/artefacts', title: 'Дополненная реальность' },
          // { to: '/museums', title: 'Виртуальные музеи' },
        ],
      },
    ],
  },
  footer: {
    title: 'Культура Амура',
    logoPath: '/images/logo_footer.svg',
    systemName: `© ${year}. Культура Амура. Портал о культурной жизни Амурской области. Все права защищены.`,
    showProCultureLogo: true,
    links: [
      { title: 'Афиша', to: '/events' },
      { title: 'Места', to: '/places' },
      { title: 'Маршруты', to: '/touristroutes' },
      { title: 'Обзоры', to: '/overviews' },
    ],
    callTime: 'В будние дни с 9:00 до 18:00',
  },
  analytics: {
    yandex: envVal({ production: '105358451' }, null),
    gtm: envVal({ production: 'GTM-MD66FX92' }, null),
    pixel: envVal({ production: '35334' }, null),
    goals: {
      paidVisit: 'events_visit_vladimir', // Todo: поменять в отдельной задаче, когда появится метрика
      paidBuy: 'buy_ticket_vladimir', // Todo: поменять в отдельной задаче, когда появится метрика
      freeVisit: 'events_visits_vladimir', // Todo: поменять в отдельной задаче, когда появится метрика
      freeNoTicketsVisit: 'noactive_free_vladimir', // Todo: поменять в отдельной задаче, когда появится метрика
      freeBuy: 'freeandzero_vladimir', // Todo: поменять в отдельной задаче, когда появится метрика
      externalLinkVisit: 'events_visit_redirect_vladimir', // Todo: поменять в отдельной задаче, когда появится метрика
      externalLinkBuy: 'buy_redirect_vladimir', // Todo: поменять в отдельной задаче, когда появится метрика
      ticketsAdd: 'entity_ticket_add', // Todo: поменять в отдельной задаче, когда появится метрика
      registration: 'kolvo_registration', // Todo: поменять в отдельной задаче, когда появится метрика
    }
  },
  unisenderNewsPopup: {
    id: envVal({ staging: '', }, null),
  },
  componentsConfig: {
    header: 'default',
    footer: 'default',
    footerSecondLogo: true,
    heroBlock: 'banner',
    socialCardIconVk: 'v2',
    socialCardIconTg: 'v2',
  },
  seo: {
    pages: {
      index: {
        title: () => 'Культура Амура — культурный портал Амурской области. culture.amurobl.ru',
        description: () => 'Культура Амура: события, площадки, маршруты, обзоры, трансляции и виртуальные музеи — всё о культурной жизни Амурской области. Официальный сайт — Культура Амура',
        titleOg: () => 'Культура Амура — культурный портал Амурской области. culture.amurobl.ru'
      },
      publicAgreement: {
        title: () => 'Политика конфиденциальности и публичная оферта',
        description: () => 'Политика конфиденциальности и публичная оферта',
      },
      events: {
        title: () => `Куда сходить в Благовещенске ${year}. Афиша ближайших мероприятий Благовещенска. Интересные культурные события. Официальный сайт — Культура Амура`,
        description: () => 'Куда можно пойти в Благовещенске. Афиша интересных мероприятий в Амурской области: описания, площадки, расписания, ☎ телефоны. Официальный сайт — Культура Амура (culture.amurobl.ru)',
        titleOg: () => '',
      },
      'tagPageDefaultSeoevents': tagPageDefaultSeoEvents,
      places: {
        title: () => `Все интересные места и достопримечательности Благовещенска ${year}. Официальный сайт — Культура Амура`,
        description: () => `Культурные площадки Благовещенска ${year}: описания, адреса, режим работы, фотографии, локации на карте. Официальный сайт — Культура Амура`,
        titleOg: () => ''
      },
      'tagPageDefaultSeoplaces': tagPageDefaultSeoPlaces,
      'tagPageDefaultSeo': tagPageDefaultSeo,
      routes: {
        title: () => `Культурные маршруты по Амурской области ${year}. Официальный сайт — Культура Амура`,
        description: () => `Лучшие культурные маршруты по Благовещенску и области — музейные, театральные, архитектурные. Карты, описания, идеи для прогулок. Официальный сайт — Культура Амура`,
        titleOg: () => ''
      },
      overviews: {
        title: () => `Обзоры ${year} — Амурская область. Официальный сайт — Культура Амура`,
        description: () => `Обзоры лучших культурных событий и площадок ${year} — Благовещенск и Амурская область. Официальный сайт — Культура Амура`,
        titleOg: () => ''
      },
      regionvideos: {
        title: () => `Видео о Амурской области, ${year}. Официальный сайт — Культура Амура`,
        description: () => `Видео о Амурской области, ${year}. Официальный сайт — Культура Амура`,
        titleOg: () => '',
      },
      hotels: {
        title: () => `Гостиницы в Амурской области ${year}. Официальный сайт — Культура Амура`,
        description: () => 'Гостиницы в Благовещенске. Подробная информация: описания, адрес, режим работы, фото, адреса на карте, рейтинги. Официальный сайт — Культура Амура',
        titleOg: () => ''
      },
      restaurants: {
        title: () => `Кафе и рестораны в Амурской области ${year}. Официальный сайт — Культура Амура`,
        description: () => 'Рестораны и кафе в Благовещенске. Подробная информация: описания, режимы работы, фото, адреса на карте, рейтинги. Официальный сайт — Культура Амура',
        titleOg: () => ''
      },
      streams: {
        title: () => 'Трансляции на сайте. Официальный сайт — Культура Амура',
        description: () => 'Все трансляции и площадки их проведения. Официальный сайт — Культура Амура',
        titleOg: () => '',
        h1: () => `Трансляции — Амурская область ${year}`,
      },
      movies: {
        title: () => `Киноафиша в Благовещенске | Афиша мероприятий с точными датами на ${year} год. Официальный сайт — Культура Амура`,
        description: () => `Киноафиша в Благовещенске на ${year} год ✅ Афиша интересных мероприятий в Амурской области. Подробная информация о событиях: ⭐ описания, места, расписания, ☎ телефоны. Официальный сайт — Культура Амура`,
        titleOg: () => ''
      },
      singleEvent: {
        title: ({ entity }) => `${entity.name} — описание, программа мероприятия, дата, время. ${entity.address}. Официальный сайт — Культура Амура`,
        description: ({ entity }) => `${entity.name}. ✅ Площадка — ${entity.placeName};
         ✅ дата — ${entity.eventDate ? moment(entity.eventDate).format('D MMMM YYYY') : ''}; ✅ ${entity.address}.
          Подробная информация: описание, фото. Официальный сайт — Культура Амура`,
        titleOg: ({ entity }) => `${entity.name}`
      },
      singlePlace: {
        title: ({ entity }) => `${entity.name}. ${entity.address}.
        Фото, режим работы, афиша и события. Официальный сайт — Культура Амура`,
        description: ({ entity }) => `${entity.name}. ${entity.address}. Подробная информация: описание,
         адрес на карте, время работы, телефон, фотографии.
          Все культурные места и достопримечательности на сайте — Культура Амура`,
        titleOg: ({ entity }) => `${entity.name}`
      },
      singleRoute: {
        title: ({ entity }) => `${entity.name}. Подробная информация: описание,
         точки на карте, фото. Официальный сайт — Культура Амура`,
        description: ({ entity }) => `${entity.name}. Лучшие культурные маршруты,
         которые можно пройти пешком или проехать на автомобиле. Официальный сайт — Культура Амура`,
        titleOg: ({ entity }) => `${entity.name}`
      },
      singleOverview: {
        title: ({ entity }) => `${entity.name}. Официальный сайт — Культура Амура`,
        description: ({ entity }) => `Обзор ${entity.name}. Официальный сайт — Культура Амура`,
        titleOg: ({ entity }) => `${entity.name}`
      },
      singleRegionVideo: {
        title: ({ entity }) => `Видео о Амурской области, ${year}. ${entity.name}. Официальный сайт — Культура Амура`,
        description: ({ entity }) => `Видео о Амурской области, ${year}. ${entity.name}. Официальный сайт — Культура Амура`,
        titleOg: ({ entity }) => `${entity.name}`,
      },
      singleHotel: {
        title: ({ entity }) => `${entity.name}. Адрес — ${entity.address}.
         Фото, режим работы. Официальный сайт — Культура Амура`,
        description: ({ entity }) => `${entity.name}. Адрес — ${entity.address} Подробная информация:
         описание, адрес на карте, время работы, телефон, фотографии. Все гостиницы на сайте — Культура Амура`,
        titleOg: ({ entity }) => `${entity.name}`
      },
      singleRestaurant: {
        title: ({ entity }) => `${entity.name}. Адрес — ${entity.address}.
         Фото, режим работы. Официальный сайт — Культура Амура`,
        description: ({ entity }) => `${entity.name}. Адрес — ${entity.address} Подробная информация:
         описание, адрес на карте, время работы, телефон, фотографии. Все рестораны на сайте — Культура Амура`,
        titleOg: ({ entity }) => `${entity.name}`
      },
      singleStream: {
        title: ({ entity }) => `Трансляция ${entity.name}. ${getStreamPlaceOrEvent(entity)}Прямая трансляция на официальном сайте — Культура Амура`,
        description: ({ entity }) => `${entity.name}. ${getStreamPlaceOrEvent(entity)}Дата и время проведения — ${entity.liveDate ? moment(entity.liveDate).format('D MMMM YYYY H:mm') : ''} на официальном сайте — Культура Амура`,
        titleOg: ({ entity }) => `${entity.name}`,
      },
      singleMovie: {
        title: ({ entity }) => `Фильм ${entity?.name} в Благовещенске  — афиша, цена на билеты,
         расписание, описание, место проведения. Официальный сайт — Культура Амура`,
        description: () => `Киноафиша Благовещенска с точным расписанием киносеансов во всех
         кинотеатрах города. Узнать цену и купить билет можно на странице с выбором фильма.
          На сайте можно узнать точное время и дату на сегодня, завтра или в другой день`,
        titleOg: ({ entity }) => `${entity.name}`
      },
      pushkincard: {
        title: () => `Пушкинская карта — АИС «Культура Амура»`,
        description: () => '',
        titleOg: () => `Пушкинская карта — АИС «Культура Амура»`,
      },
      main: { title: 'Благовещенск. Культура Амура' },
      museums: {
        title: () => 'Виртуальные музеи Амурской области. Официальный сайт — Культура Амура',
        description: () => 'Виртуальные музеи Благовещенска и области. Официальный сайт — Культура Амура'
      },
      singleMuseum: {
        title: ({ entity }) => `Виртуальные музеи. ${entity.name}. Официальный сайт — Культура Амура`,
        description: ({ entity }) => `Виртуальные музеи. ${entity.name} — посетить музей онлайн. Официальный сайт — Культура Амура`
      },
      halls: {
        title: () => `Виртуальные концертные залы, ${year} — Амурская область. Официальный сайт — Культура Амура`,
        description: () => `Виртуальные концертные залы, ${year}. Амурская область. Официальный сайт — Культура Амура`
      },
      singleHall: {
        title: ({ entity }) => `Виртуальные концертные залы, ${year}, ${entity.name}. Амурская область. Официальный сайт — Культура Амура`,
        description: ({ entity }) => `Виртуальные концертные залы, ${year}, ${entity.name}. Амурская область. Официальный сайт — Культура Амура`
      },
      artefacts: {
        title: () => 'Дополненная реальность. Официальный сайт — Культура Амура',
        description: () => 'Дополненная реальность: объекты и маршруты с AR-сценами. Официальный сайт — Культура Амура'
      },
      singleArtefact: {
        title: ({ entity }) => `${entity?.name}. Официальный сайт — Культура Амура`,
        description: ({ entity }) => `${entity?.name}. Объект дополненной реальности. Официальный сайт — Культура Амура`,
      },
      search: {
        title: ({ searchQuery }) => `Поиск событий, мест, маршрутов, обзоров,
        ресторанов, гостиниц по запросу «${searchQuery}»`,
        description: ({ searchQuery }) => `События, места, маршруты, обзоры,
        рестораны, гостиницы по запросу «${searchQuery}»`,
      },
      faq: {
        title: () => `Часто задаваемые вопросы. Официальный сайт — Культура Амура`,
        description: () => 'Часто задаваемые вопросы. Официальный сайт — Культура Амура',
      },
      // Порядок вложенности необходимо соблюдать, иначе функция получения сео метаданных отработает неправильно
      // В единсвенном числе — фильтр (locale, place, date, ...), с приставкой Page(eventsPage, hotelsPage, ...) — страница, для которой метаданные
      // Примеры:
      // locale->date->eventsPage: Фильтр район + фильтр дата для страницы событий
      // place->tag->eventsPage->default: Фильтр место + тэг для страницы событий
      // tag->eventsPage->pushkinskaya-karta: Тэг Пушкцинская карта для страницы событий
      filters: {
        locale: {
          eventsPage: {
            title: ({ localeName }) => `${localeName} — афиша ${year}. Интересные развлекательные события. Официальный сайт — Культура Амура`,
            description: ({ localeName }) => `${localeName} — афиша интересных мероприятий. Подробная информация о событиях: описания, места проведения, расписания, ☎ телефоны. Официальный сайт — Культура Амура`,
            h1: ({ localeName }) => `${localeName} — афиша`,
          },
          placesPage: {
            title: ({ localeName }) => `Интересные места — ${localeName} ${year}. Официальный сайт -— Культура Амура`,
            description: ({ localeName }) => `Все интересные места и достопримечательности — ${localeName} ${year} — описания, цены на билеты, режим работы, фотографии, адреса на карте. Официальный сайт — Культура Амура`,
            h1: ({ localeName }) => `Места — ${localeName}`,
          },
          restaurantsPage: {
            title: ({ localeName }) => `Кафе и рестораны — ${localeName} ${year}. Официальный сайт — Культура Амура`,
            description: ({ localeName }) => `Кафе и рестораны — ${localeName}. Подробная информация: описания, режимы работы, фото, адреса на карте, рейтинги. Официальный сайт — Культура Амура`,
            h1: ({ localeName }) => `Кафе и рестораны — ${localeName}`
          },
          hotelsPage: {
            title: ({ localeName }) => `Гостиницы и отели — ${localeName} ${year}. Официальный сайт — Культура Амура`,
            description: ({ localeName }) => `Гостиницы и отели — ${localeName}. Подробная информация: описания, режимы работы, фото, адреса на карте, рейтинги, парковка, завтраки, спа и т. д. Официальный сайт — Культура Амура`,
            h1: ({ localeName }) => `Гостиницы и отели — ${localeName}`
          },
          tag: {
            eventsPage: {
              default: {
                title: ({ localeName, tagName }) => `${capitalize(localeName)} — ${tagName}. Интересные развлекательные события. Официальный сайт — Культура Амура`,
                description: ({ localeName, tagName }) => `${capitalize(tagName)} — ${localeName}. Подробная информация о мероприятиях: расписания, описания, фото, места проведения, цены на билеты. Официальный сайт — Культура Амура`,
                h1: ({ localeName, tagName }) => `${capitalize(localeName)} — ${tagName}`,
              }
            },
            placesPage: {
              default: {
                title: ({ localeName, tagName }) => `${capitalize(tagName)} — ${localeName} ${year}. Интересные места. Официальный сайт — Культура Амура`,
                description: ({ localeName, tagName }) => `${capitalize(tagName)} — ${localeName}. Подробная информация о месте: описания, фото, адрес на карте, время работы. Официальный сайт — Культура Амура`,
                h1: ({ localeName, tagName }) => `${capitalize(tagName)} — ${localeName}`,
              }
            },
            hotelsPage: {
              default: {
                title: ({ localeName, tagName }) => `${capitalize(tagName)} — ${localeName} ${year}. Интересные места. Официальный сайт — Культура Амура`,
                description: ({ localeName, tagName }) => `${capitalize(tagName)} — ${localeName}. Подробная информация о месте: описания, фото, адрес на карте, время работы. Официальный сайт — Культура Амура`,
                h1: ({ localeName, tagName }) => `${capitalize(tagName)} — ${localeName}`,
              }
            },
            restaurantsPage: {
              default: {
                title: ({ localeName, tagName }) => `${capitalize(tagName)} — ${localeName} ${year}. Интересные места. Официальный сайт — Культура Амура`,
                description: ({ localeName, tagName }) => `${capitalize(tagName)} — ${localeName}. Подробная информация о месте: описания, фото, адрес на карте, время работы. Официальный сайт — Культура Амура`,
                h1: ({ localeName, tagName }) => `${capitalize(tagName)} — ${localeName}`,
              }
            }
          },
          place: {
            eventsPage: {
              title: ({ placeName }) => `${placeName} — афиша ${year}. Интересные развлекательные события. Официальный сайт — Культура Амура`,
              description: ({ placeName }) => `${placeName} — афиша интересных мероприятий. Подробная информация о событиях: описания, места проведения, расписания, ☎ телефоны. Официальный сайт — Культура Амура`,
              h1: ({ placeName }) => `${placeName} — афиша`,
            }
          },
          date: {
            eventsPage: {
              title: ({ localeName, date }) => `${capitalize(localeName)} — афиша на ${date} ${year} года. Интересные развлекательные события. Официальный сайт — Культура Амура`,
              description: ({ localeName, date }) => `${capitalize(localeName)} — афиша на ${date} ${year} года. Интересные мероприятия во Амурской области. Подробная информация о событиях: описания, места проведения, расписания, ☎ телефоны. Официальный сайт — Культура Амура`,
              h1: ({ localeName, date }) => `${capitalize(localeName)} — афиша на ${date}`,
            }
          },
          interim: {
            eventsPage: {
              title: ({ localeName, interim, formattedDate, formattedYear }) => `${capitalize(localeName)} — афиша на ${interim}, ${formattedDate} ${formattedYear} года. Интересные развлекательные события. Официальный сайт — Культура Амура`,
              description: ({ localeName, interim, formattedDate, formattedYear }) => `${capitalize(localeName)} — афиша на ${interim}, ${formattedDate} ${formattedYear} года. Интересные мероприятия. Подробная информация о событиях: описания, места проведения, расписания, ☎ телефоны. Официальный сайт — Культура Амура`,
              h1: ({ localeName, interim, formattedDate }) => `${capitalize(localeName)} — афиша на ${interim}, ${formattedDate}`,
            }
          }
        },
        place: {
          eventsPage: {
            title: ({ placeName }) => `${placeName} — афиша ${year}. Интересные развлекательные события. Официальный сайт — Культура Амура`,
            description: ({ placeName }) => `${placeName} — афиша интересных мероприятий. Подробная информация о событиях: описания, места проведения, расписания, ☎ телефоны. Официальный сайт — Культура Амура`,
            h1: ({ placeName }) => `${placeName} — афиша`,
          },
          streamsPage: {
            title: ({ placeName }) => `Трансляции — ${placeName} ${year}. Официальный сайт — Культура Амура`,
            description: ({ placeName }) => `Трансляции — ${placeName} ${year}. Прямые трансляции: смотреть онлайн и бесплатно. Официальный сайт — Культура Амура`,
            h1: ({ placeName }) => `Трансляции — ${placeName}`
          },
          date: {
            eventsPage: {
              title: ({ placeName, date }) => `${capitalize(placeName)} — афиша на ${date} ${year} года. Интересные развлекательные события. Официальный сайт — Культура Амура`,
              description: ({ placeName, date }) => `${capitalize(placeName)} — афиша на ${date} ${year} года. Интересные мероприятия в Амурской области. Подробная информация о событиях: описания, места проведения, расписания, ☎ телефоны. Официальный сайт — Культура Амура`,
              h1: ({ placeName, date }) => `${capitalize(placeName)} — афиша на ${date}`
            },
            streamsPage: {
              title: ({ placeName, date }) => `${capitalize(placeName)} — трансляции на ${date} ${year} года. Интересные развлекательные трансляции. Официальный сайт — Культура Амура`,
              description: ({ placeName, date }) => `${capitalize(placeName)} — трансляции на ${date} ${year} года. Интересные трансляции — Амурская область. Подробная информация о трансляциях: описания, время проведения, расписания, ☎ телефоны. Официальный сайт — Культура Амура`,
              h1: ({ placeName, date }) => `${capitalize(placeName)} — трансляции на ${date}`
            }
          },
          interim: {
            eventsPage: {
              title: ({ placeName, interim, formattedDate, formattedYear }) => `${capitalize(placeName)} — афиша на ${interim}, ${formattedDate} ${formattedYear} года. Интересные развлекательные события. Официальный сайт — Культура Амура`,
              description: ({ placeName, interim, formattedDate, formattedYear }) => `${capitalize(placeName)} — афиша на ${interim}, ${formattedDate} ${formattedYear} года. Интересные мероприятия. Подробная информация о событиях: описания, места проведения, расписания, ☎ телефоны. Официальный сайт — Культура Амура`,
              h1: ({ placeName, interim, formattedDate }) => `${capitalize(placeName)} — афиша на ${interim}, ${formattedDate}`,
            },
            streamsPage: {
              title: ({ placeName, interim, formattedDate, formattedYear }) => `${capitalize(placeName)} — трансляции на ${interim}, ${formattedDate} ${formattedYear} года. Интересные развлекательные трансляции. Официальный сайт — Культура Амура`,
              description: ({ placeName, interim, formattedDate, formattedYear }) => `${capitalize(placeName)} — трансляции на ${interim}, ${formattedDate} ${formattedYear} года. Интересные трансляции — Амурская область. Подробная информация о трансляциях: описания, время проведения, расписания, ☎ телефоны. Официальный сайт — Культура Амура`,
              h1: ({ placeName, interim, formattedDate }) => `${capitalize(placeName)} — трансляции на ${interim}, ${formattedDate}`,
            }
          },
          tag: {
            eventsPage: {
              default: {
                title: ({ tagName, placeName }) => `${capitalize(placeName)} — ${tagName}. Интересные развлекательные события. Официальный сайт — Культура Амура`,
                description: ({ tagName, placeName }) => `${capitalize(placeName)} — ${tagName}. Подробная информация о мероприятиях: расписания, описания, фото, места проведения, цены на билеты. Официальный сайт — Культура Амура`,
                h1: ({ tagName, placeName }) => `${capitalize(placeName)} — ${tagName}`,
              }
            }
          }
        },
        date: {
          eventsPage: {
            title: ({ formattedDate }) => `Афиша Благовещенска на ${formattedDate} года. Интересные развлекательные события в Благовещенске. Официальный сайт — Культура Амура`,
            description: ({ formattedDate }) => `Афиша в Благовещенске на ${formattedDate} года. Интересные мероприятия Благовещенска. Подробная информация о событиях: описания, места проведения, расписания, ☎ телефоны. Официальный сайт — Культура Амура`,
            h1: ({ date }) => `Афиша на ${date}`,
          },
          moviesPage: {
            title: ({ formattedDate }) => `Киноафиша в Благовещенске на ${formattedDate}. Кино в Благовещенске — ${formattedDate}. Официальный сайт — Культура Амура`,
            description: ({ formattedDate }) => `Кино в Благовещенске — ${formattedDate} ✅ Киноафиша в Благовещенске на ${formattedDate}. Подробная информация о кино: ⭐ описания, цены, кинотеатры, расписания, ☎ телефоны. Официальный сайт — Культура Амура`,
            h1: ({ date }) => `Киноафиша на ${date}`,
          },
          streamsPage: {
            title: ({ formattedDate }) => `Трансляции ${formattedDate} года. Официальный сайт — Культура Амура`,
            description: ({ formattedDate }) => `Трансляции — ${formattedDate} года. Прямые трансляции: смотреть онлайн и бесплатно. Официальный сайт — Культура Амура`,
            h1: ({ date }) => `Трансляции — ${date}`,
          },
          tag: {
            eventsPage: {
              default: {
                title: ({ tagName, formattedDate }) => `${capitalize(tagName)} — афиша на ${formattedDate} года. Интересные развлекательные события. Официальный сайт — Культура Амура`,
                description: ({ tagName, formattedDate }) => `${capitalize(tagName)} — афиша на ${formattedDate} года. Интересные мероприятия — Амурская область. Подробная информация о мероприятиях: описания, места проведения, расписания, ☎ телефоны. Официальный сайт — Культура Амура`,
                h1: ({ tagName, date }) => `${capitalize(tagName)} — афиша на ${date}`,
              }
            },
          },
          genre: {
            moviesPage: {
              title: ({ genreName, formattedDate }) => `Киноафиша в жанре ${genreName} на ${formattedDate} года — Амурская область. Официальный сайт — Культура Амура`,
              description: ({ genreName, formattedDate }) => `Кино в жанре ${genreName} на ${formattedDate} года — Амурская область. Киноафиша на ${formattedDate} года — Амурская область. Подробная информация о кино: описания, цены, кинотеатры, расписания, ☎ телефоны. Официальный сайт — Культура Амура`,
              h1: ({ genreName, date }) => `Киноафиша в жанре ${genreName} на ${date}`,
            }
          }
        },
        interim: {
          eventsPage: {
            title: ({ interim, formattedDate }) => `Афиша на ${interim}, ${formattedDate} в Благовещенске. Интересные развлекательные события в Благовещенске. Официальный сайт — Культура Амура`,
            description: ({ interim, formattedDate }) => `Афиша Благовещенска на ${interim}, ${formattedDate}. Интересные мероприятия Благовещенска. Подробная информация о событиях: описания, места проведения, расписания, ☎ телефоны. Официальный сайт — Культура Амура`,
            h1: ({ interim, formattedDate }) => `Афиша на ${interim}, ${formattedDate}`,
          },
          moviesPage: {
            title: ({ interim, formattedDate, formattedYear }) => `Киноафиша на ${interim}, ${formattedDate} ${formattedYear} года в Благовещенске. Кино в Благовещенске ${interim}, на ${formattedDate} ${formattedYear} года. Официальный сайт — Культура Амура`,
            description: ({ interim, formattedDate, formattedYear }) => `Кино в Благовещенске на ${interim}, ${formattedDate} ${formattedYear} года ✅ Киноафиша в Благовещенске ${interim}, ${formattedDate} ${formattedYear} года. Подробная информация о кино: ⭐ описания, цены, кинотеатры, расписания, ☎ телефоны. Официальный сайт — Культура Амура`,
            h1: ({ interim, formattedDate }) => `Киноафиша на ${interim}, ${formattedDate}`,
          },
          streamsPage: {
            title: ({ interim, formattedDate, formattedYear }) => `Трансляции на ${interim}, ${formattedDate} ${formattedYear} года. Официальный сайт — Культура Амура`,
            description: ({ interim, formattedDate, formattedYear }) => `Трансляции на ${interim}, ${formattedDate} ${formattedYear} года. Прямые трансляции: смотреть онлайн и бесплатно. Официальный сайт — Культура Амура`,
            h1: ({ interim, formattedDate }) => `Трансляции на ${interim}, ${formattedDate}`,
          },
          tag: {
            eventsPage: {
              default: {
                title: ({ tagName, interim, formattedDate }) => `${capitalize(tagName)} — афиша на ${interim}, ${formattedDate} ${year} года. Интересные развлекательные события. Официальный сайт — Культура Амура`,
                description: ({ tagName, interim, formattedDate }) => `${capitalize(tagName)} — афиша на ${interim}, ${formattedDate} ${year} года. Интересные мероприятия. Подробная информация о событиях: описания, места проведения, расписания, ☎ телефоны. Официальный сайт — Культура Амура`,
                h1: ({ tagName, interim, formattedDate }) => `${capitalize(tagName)} — афиша на ${interim}, ${formattedDate}`,
              }
            },
          },
          genre: {
            moviesPage: {
              title: ({ genreName, interim, formattedDate }) => `Киноафиша в жанре ${genreName} на ${interim}, ${formattedDate} ${year} года — Амурская область. Официальный сайт — Культура Амура`,
              description: ({ genreName, interim, formattedDate }) => `Кино в жанре ${genreName} на ${interim}, ${formattedDate} ${year} года — Амурская область. Киноафиша на ${interim} ${formattedDate} ${year} года — Амурская область. Подробная информация о кино: описания, цены, кинотеатры, расписания, ☎ телефоны. Официальный сайт — Культура Амура`,
              h1: ({ genreName, interim, formattedDate }) => `Киноафиша в жанре ${genreName} на ${interim}, ${formattedDate}`,
            }
          }
        },
        tag: {
          eventsPage: {
            'pushkinskaya-karta': {
              title: () => `Пушкинская карта ${year} в Благовещенске. Купить билеты по Пушкинской карте в Благовещенске. Официальный сайт — Культура Амура`,
              description: () => `Афиша мероприятий по Пушкинской карте Благовещенска. Купить билеты по Пушкинской карте в кино, на концерты, на спектакли и другие мероприятия. Официальный сайт — Культура Амура`,
              h1: () => `Пушкинская карта`
            },
            'koncerty-i-shou': {
              title: () => `Концерты в Благовещенске ${year}. Афиша концертов Благовещенска. Официальный сайт — Культура Амура`,
              description: () => `Расписания концертов в Благовещенске. Купить билеты на концерты в Благовещенске. Подробная информация о событиях: расписания, описания, фото, места проведения, цены на билеты. Официальный сайт — Культура Амура`,
              h1: () => `Концерты и шоу`
            },
            'spektakli': {
              title: () => `Спектакли в Благовещенске ${year}. Купить билеты на спектакль в Благовещенске. Официальный сайт — Культура Амура`,
              description: () => `Афиша спектаклей в Благовещенске. Купить билеты на спектакль в Благовещенске. Подробная информация о событиях: расписания, описания, фото, места проведения, цены на билеты. Официальный сайт — Культура Амура`,
              h1: () => `Спектакли`
            },
            'detyam': {
              title: () => `Детская афиша в Благовещенске ${year}. Куда пойти с ребенком в Благовещенске. Официальный сайт — Культура Амура`,
              description: () => `Детские мероприятия в Благовещенске. Куда пойти с ребенком в Благовещенске. Подробная информация о событиях: расписания, описания, фото, места проведения, цены на билеты. Официальный сайт — Культура Амура`,
              h1: () => `Детям`
            },
            default: tagPageDefaultSeo
          },
          streamsPage: {
            default: {
              title: ({ tagName }) => `Трансляции — ${tagName}. Официальный сайт — Культура Амура`,
              description: ({ tagName }) => `Трансляции — ${tagName}. Прямые трансляции: смотреть онлайн и бесплатно Официальный сайт — Культура Амура`,
              h1: ({ tagName }) => `Трансляции — ${tagName}`,
            }
          },
          restaurantsPage: {
            default: {
              title: ({ tagName }) => `${tagName} Благовещенска ${year}. Официальный сайт — Культура Амура`,
              description: ({ tagName }) => `${tagName} в Благовещенске. Подробная информация: описания, режимы работы, фото, адреса на карте, рейтинги. Официальный сайт — Культура Амура`,
              h1: ({ tagName }) => tagName,
            }
          },
          hotelsPage: {
            default: {
              title: ({ tagName }) => `Гостиницы и отели — ${tagName} ${year}. Официальный сайт — Культура Амура`,
              description: ({ tagName }) => `Гостиницы и отели — ${tagName}. Подробная информация: описания, режимы работы, фото, адреса на карте, рейтинги, парковка, завтраки, спа и т. д. Официальный сайт — Культура Амура`,
              h1: ({ tagName }) => `Гостиницы и отели — ${tagName}`,
            }
          }
        },
        genre: {
          moviesPage: {
            title: ({ genreName }) => `Киноафиша в Благовещенске, жанр — ${genreName}. Кино в Благовещенске, жанр — ${genreName}. Официальный сайт — Культура Амура`,
            description: ({ genreName }) => `Кино в Благовещенске, жанр — ${genreName} ✅ Киноафиша в Благовещенске, жанр — ${genreName}. Подробная информация о кино: ⭐ описания, цены, кинотеатры, расписания, ☎ телефоны. Официальный сайт — Культура Амура`,
            h1: ({ genreName }) => `Киноафиша, жанр — ${genreName}`
          },
        }
      },
    },
  },
  homePageBlocks: [
    'best',
    'events',
    'subscribe',
    'places',
    'overviews',
    'routes',
    'socials',
    'restaurants',
    'hotels',
  ]
};
